import { precacheAndRoute } from 'workbox-precaching';

export const APP_VERSION = "1.4.2"
console.info("Version: ", APP_VERSION);

// manifest import will be autogenerated by webpack
precacheAndRoute(self.__WB_MANIFEST || []);